import { useState } from 'react'
import { InputCheck } from '../../../../../../Forms/InputCheck'

import { Container } from './style'

export function Franchise({ 
    franchise, 
    franchiseListChecked,
    setFranchiseListChecked 
}) {
    const [checked, setChecked] = useState(franchiseListChecked.some(id => id === franchise.id))

    function handleClick() {
        if(checked) {
            setFranchiseListChecked(oldList => oldList.filter(id => id !== franchise.id))
            setChecked(false)
            return
        }

        setChecked(true)
        setFranchiseListChecked(oldList => [...oldList, franchise.id])
    }


    return (
        <Container>
            <InputCheck 
                checked={checked}
                handleClick={handleClick}
            />

            <p>{franchise.name}</p>
        </Container>
    )
}